(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games/assets/javascripts/page-category-games.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games/assets/javascripts/page-category-games.js');

'use strict';

const {
  useEffect
} = React;
const {
  useParams
} = ReactRouterDOM;
const ErrorPage = svs.components.casino_react.page_error;
const {
  GridDisplayModes
} = svs.components.casino_react.common.constants;
const {
  CasinoSection
} = svs.components.casino_react.casinoSection;
const {
  cmsCategoryList,
  cmsLiveCategoryList
} = svs.casino_react.shared.data;
const {
  setMetaTags
} = svs.components.lbUtils.setMetaTags;
const {
  SubHeader
} = svs.components.casino_react.sub_header;
const {
  useGetSearchResultQuery
} = svs.components.casino_react.casinoStore.endpoints.searchApi;
const {
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  FilterAndSort
} = svs.components.casino_react.filterAndSort;
const actionButtons = () => React.createElement(FilterAndSort, null);
const useGetCategoryGames = _ref => {
  let {
    listIds,
    shouldSkipFetch
  } = _ref;
  const {
    tags,
    categories,
    sorting,
    providers
  } = useSearchParams();
  const {
    data,
    isLoading,
    error,
    isFetching
  } = useGetSearchResultQuery({
    providers,
    listIds,
    categories,
    tags,
    sorting
  }, {
    skip: shouldSkipFetch,
    selectFromResult: result => {
      if (shouldSkipFetch || !(result !== null && result !== void 0 && result.data)) {
        return {
          data: {
            games: null,
            error: null,
            totalCount: null
          }
        };
      }
      return result;
    }
  });
  return {
    data,
    isLoading,
    error,
    isFetching
  };
};
const PageCategoryGames = () => {
  var _contentList$find$mod, _contentList$find, _data$games;
  const {
    categoryType,
    categoryName
  } = useParams();
  const contentList = categoryType === 'live' ? cmsLiveCategoryList : cmsCategoryList;
  const categoryModel = (_contentList$find$mod = (_contentList$find = contentList.find(game => game.model.systemName === categoryName)) === null || _contentList$find === void 0 ? void 0 : _contentList$find.model) !== null && _contentList$find$mod !== void 0 ? _contentList$find$mod : {};
  const {
    data,
    isLoading,
    error,
    isFetching
  } = useGetCategoryGames({
    listIds: [categoryModel.contentList]
  });
  useEffect(() => {
    setMetaTags({
      docTitle: categoryModel.metaTitle,
      metaDesc: categoryModel.metaDescription
    });
  }, [categoryModel.metaTitle, categoryModel.metaDescription]);
  if (error) {
    return React.createElement(ErrorPage, null);
  }
  return React.createElement(React.Fragment, null, React.createElement(SubHeader, {
    title: categoryModel.name
  }), React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    isLoading: isLoading || isFetching,
    isSearchResult: (data === null || data === void 0 || (_data$games = data.games) === null || _data$games === void 0 ? void 0 : _data$games.length) === 0,
    items: data !== null && data !== void 0 && data.games ? data.games : [],
    title: data !== null && data !== void 0 && data.totalCount ? "".concat(data.totalCount, " spel") : ''
  }));
};
setGlobal('svs.components.casino_react.pageCategoryGames.PageCategoryGames', PageCategoryGames);

 })(window);